// Part of salesPages, split by screen to keep files short; ../salesPages.ts merges the parts.
// Keys sit directly under salesPages, in sub-objects whose names no other part uses.
// Receive payment form; product/service and customer/vendor drawer checks (lib/item-form.ts,
// lib/contact-form.ts).
export const en = {
  receivePaymentForm: {
    saved: 'Payment {{number}} saved.',
    creditsApplied: 'Credits of {{amount}} applied.',
    chooseDeposit: 'Choose a payment account to deposit to.',
    enterAmount: 'Enter the amount received or choose credits to apply.',
    overApplying: 'You are applying {{applying}} but only have {{have}}.',
    creditsOverInvoices: 'Apply credits only up to the invoices you are paying.',
    customerRequired: 'Customer *',
    chooseCustomer: 'Choose a customer',
    amountReceivedIn: 'Amount received ({{currency}})',
    chooseCustomerHint: 'Choose a customer to see their outstanding invoices.',
    outstanding: 'Outstanding transactions',
    outstandingInvoices: 'Outstanding invoices',
    colDescription: 'Description',
    colOriginalAmount: 'Original amount',
    overdueSuffix: ' · overdue',
    noOpenInvoices:
      'This customer has no open invoices. A payment saved now stays on their account as a credit.',
    credits: 'Credits',
    useCredit: 'Use {{number}}',
    creditLine: {
      credit_note: 'Credit note {{number}}',
      journal_entry: 'Journal entry {{number}}',
      payment: 'Unapplied payment {{number}}',
    },
    available: 'Available {{amount}}',
    creditFrom: 'Credit from {{number}}',
    amountToApply: 'Amount to apply',
    creditsUsed: 'Credits used',
    amountToCredit: 'Amount to credit',
    exchangeGain: 'Exchange gain ({{currency}})',
    exchangeLoss: 'Exchange loss ({{currency}})',
    footnote:
      'Typing the amount received applies it to the oldest invoices first. Shortcuts: Ctrl+Alt+S save and close · Ctrl+Alt+D save and new · Ctrl+Alt+X close.',
  },
  itemChecks: {
    soldOrPurchased: 'Tick at least one: you sell it, you purchase it, or both.',
    hsnSac: 'An HSN or SAC code has 4, 6 or 8 digits.',
    uqc: 'A unit quantity code has three letters, such as NOS.',
    incomeAccount: 'Choose the income account.',
    salesPrice: 'Enter a price such as 1250 or 99.50.',
    expenseAccount: 'Choose the expense account.',
    purchasePrice: 'Enter a cost such as 1250 or 99.50.',
    inventoryAccount: 'Choose the inventory asset account.',
    initialQuantity: 'Enter a quantity such as 25 or 2.5.',
    reorderPoint: 'Enter a quantity such as 10.',
  },
  contactChecks: {
    enterDisplayName: 'Enter a display name.',
    vatNeedsTrn: 'A VAT-registered contact needs its TRN.',
    accountOrIban: 'Enter the account number and IFSC (for example {{example}}), or an IBAN.',
    invalidIban: 'Enter a valid IBAN (for example {{example}}).',
    uaeIbanLength: 'A UAE IBAN has 23 characters.',
  },
};

export const ar = {
  receivePaymentForm: {
    saved: 'تم حفظ سند القبض {{number}}.',
    creditsApplied: 'تم تطبيق أرصدة دائنة بقيمة {{amount}}.',
    chooseDeposit: 'اختر حساب الدفع الذي يُودَع فيه المبلغ.',
    enterAmount: 'أدخل المبلغ المستلم أو اختر أرصدة دائنة لتطبيقها.',
    overApplying: 'أنت تطبّق {{applying}} بينما المتاح لديك {{have}} فقط.',
    creditsOverInvoices: 'طبّق الأرصدة الدائنة بحدود الفواتير التي تسددها فقط.',
    customerRequired: 'العميل *',
    chooseCustomer: 'اختر عميلاً',
    amountReceivedIn: 'المبلغ المستلم ({{currency}})',
    chooseCustomerHint: 'اختر عميلاً لعرض فواتيره المستحقة.',
    outstanding: 'المعاملات المستحقة',
    outstandingInvoices: 'الفواتير المستحقة',
    colDescription: 'الوصف',
    colOriginalAmount: 'المبلغ الأصلي',
    overdueSuffix: ' · متأخرة',
    noOpenInvoices:
      'لا توجد لدى هذا العميل فواتير مفتوحة. الدفعة التي تُحفظ الآن تبقى في حسابه رصيداً دائناً.',
    credits: 'الأرصدة الدائنة',
    useCredit: 'استخدام {{number}}',
    creditLine: {
      credit_note: 'إشعار دائن {{number}}',
      journal_entry: 'قيد يومية {{number}}',
      payment: 'دفعة غير مطبّقة {{number}}',
    },
    available: 'المتاح {{amount}}',
    creditFrom: 'رصيد دائن من {{number}}',
    amountToApply: 'المبلغ المطلوب تطبيقه',
    creditsUsed: 'الأرصدة الدائنة المستخدمة',
    amountToCredit: 'المبلغ المقيّد رصيداً دائناً',
    exchangeGain: 'ربح صرف ({{currency}})',
    exchangeLoss: 'خسارة صرف ({{currency}})',
    footnote:
      'إدخال المبلغ المستلم يطبّقه على أقدم الفواتير أولاً. الاختصارات: Ctrl+Alt+S حفظ وإغلاق · Ctrl+Alt+D حفظ وجديد · Ctrl+Alt+X إغلاق.',
  },
  itemChecks: {
    soldOrPurchased: 'حدّد خياراً واحداً على الأقل: تبيعه، أو تشتريه، أو كليهما.',
    hsnSac: 'يتكون رمز HSN أو SAC من 4 أو 6 أو 8 أرقام.',
    uqc: 'يتكون رمز وحدة الكمية من ثلاثة أحرف، مثل NOS.',
    incomeAccount: 'اختر حساب الإيرادات.',
    salesPrice: 'أدخل سعراً مثل 1250 أو 99.50.',
    expenseAccount: 'اختر حساب المصروفات.',
    purchasePrice: 'أدخل تكلفة مثل 1250 أو 99.50.',
    inventoryAccount: 'اختر حساب أصل المخزون.',
    initialQuantity: 'أدخل كمية مثل 25 أو 2.5.',
    reorderPoint: 'أدخل كمية مثل 10.',
  },
  contactChecks: {
    enterDisplayName: 'أدخل اسم العرض.',
    vatNeedsTrn: 'جهة الاتصال المسجّلة في ضريبة القيمة المضافة تحتاج إلى رقم TRN الخاص بها.',
    accountOrIban: 'أدخل رقم الحساب ورمز IFSC (مثل {{example}})، أو رقم IBAN.',
    invalidIban: 'أدخل رقم IBAN صحيحاً (مثل {{example}}).',
    uaeIbanLength: 'يتكون رقم IBAN الإماراتي من 23 حرفاً.',
  },
};
